import adrianPic from "@/public/images/artists/adrian.jpg";
import { Artist } from "@/types/types";

export const adrian = {
  id: "218",
  name: "Adrian",
  image: adrianPic,
  description: `Adrian's voice is smooth and grounded, with a deep tone that's warm and slightly textured. His delivery is natural and effortless, equally at home on catchy hooks or introspective verses, with a sound made for alternative and contemporary hip-hop.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fadrian-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 62,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
